/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Shared template dependencies for the eagerly loaded advertising features.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {PercentageBarComponent} from '../common/controller/progress-bar-percentage-component';
import {VelocityComponent} from '../common/controller/velocity-component';
import {RateLimitComponent} from '../common/controller/rate-limit.component';
import {ListColumnSelectorComponent} from '../common/controller/list-column-selector.component';
import {QueryColumnSelectorComponent} from '../common/controller/query-column-selector.component';
import {PublisherStatsModule} from '../common/controller/publisher-stats.module';
import {SearchSelectComponent} from '../common/controller/search-select.component';
import {AdnTeamSelectorComponent} from '../common/controller/team-selector.component';
import {StatsTablesModule} from '../common/controller/stats-tables.module';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {AdminListModule} from '../common/directives/admin-list.module';
import {ChartsModule} from '../common/directives/charts.module';
import {CodemirrorFieldComponent} from '../common/directives/codemirror-field.component';
import {AdnCountrySelectComponent} from '../common/directives/country-select/adn-country-select.component';
import {CountrySelectComponent} from '../common/directives/country-select/country-select';
import {ExplorationComponent} from '../common/directives/exploration.component';
import {ExplorationTableComponent} from '../common/directives/exploration-table.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {AdminRichTextFieldComponent} from '../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../common/directives/notes/object-notes-button.component';
import {ObjectStatesComponent} from '../common/directives/object-states.component';
import {ViewObjectStatesComponent} from '../common/directives/view-object-states.component';
import {ConfirmObjectStateModalComponent} from '../common/directives/confirm-object-state-modal.component';
import {ListSelectInFilterComponent} from '../common/directives/list-select-in-filter.component';
import {AdStatusLabelComponent} from '../ad-unit/ad-status-component';
import {AdvertiserStatusLabelComponent} from '../advertiser/advertiser-status-component';
import {CreativeAssetsModule} from '../creative/creative-assets.module';
import {CreativePreviewModule} from '../creative/creative-preview.module';
import {LineItemLabelsModule} from '../line-item/line-item-labels.module';
import {BudgetViewComponent} from '../order/budget-view.component';
import {PaymentStatusLabelComponent} from '../payment/payment-status-component';
import {ReportWidgetsModule} from '../report/report-widgets.module';
import {TargetingModule} from '../targeting/targeting.module';

const ADVERTISING_TEMPLATE_MODULES = [
  AppSharedModule,
  FormsModule,
  TranslateModule,
  UIRouterModule,
  ButtonsModule,
  CollapseModule,
  BsDatepickerModule,
  BsDropdownModule,
  PopoverModule,
  TabsModule,
  TimepickerModule,
  AdminListModule,
  AdminResourcePagesModule,
  AdnSelectComponent,
  ChartsModule,
  CodemirrorFieldComponent,
  AdnCountrySelectComponent,
  CountrySelectComponent,
  CreativeAssetsModule,
  CreativePreviewModule,
  PercentageBarComponent,
  VelocityComponent,
  RateLimitComponent,
  ExplorationComponent,
  ExplorationTableComponent,
  FormControlsModule,
  LineItemLabelsModule,
  ListColumnSelectorComponent,
  QueryColumnSelectorComponent,
  ListSelectInFilterComponent,
  AdminRichTextFieldComponent,
  NotesComponent,
  ObjectNotesButtonComponent,
  ObjectStatesComponent,
  ViewObjectStatesComponent,
  ConfirmObjectStateModalComponent,
  PaymentStatusLabelComponent,
  PublisherStatsModule,
  ReportWidgetsModule,
  AdStatusLabelComponent,
  AdvertiserStatusLabelComponent,
  SearchSelectComponent,
  AdnTeamSelectorComponent,
  StatsTablesModule,
  TargetingModule
];

@NgModule({
  imports: ADVERTISING_TEMPLATE_MODULES,
  declarations: [BudgetViewComponent],
  exports: [
    ...ADVERTISING_TEMPLATE_MODULES,
    BudgetViewComponent
  ]
})
export class AdvertisingSharedModule {
}
